<template>
<div class="chapter">
<div class="inner_page">
<div class="wrap">
<p class="image"><img alt="image" class="horizontal" src="images/end1.jpg"/></p>
</div>
<div class="pagebreak">
<p class="halftitle">The Gardener Says</p>
<div class="pagebreak">
<p class="first1_noindent"><a id="page_2"></a>Also available in the<br/>Words of Wisdom series:</p>
<p class="first2_noindent"><span class="font5"><strong>The Architect Says</strong></span></p>
<p class="text_noindent">Laura S. Dushkes</p>
<p class="first2_noindent"><span class="font5"><strong>The Designer Says</strong></span></p>
<p class="text_noindent">Sara Bader</p>
<p class="first2_noindent"><span class="font5"><strong>The Filmmaker Says</strong></span></p>
<p class="text_noindent">Jamie Thompson Stern</p>
<p class="first2_noindent"><span class="font5"><strong>The Chef Says</strong></span></p>
<p class="text_noindent">Nach Waxman and Matt Sartwell</p>
<p class="first2_noindent"><span class="font5"><strong>The Musician Says</strong></span></p>
<p class="text_noindent">Benedetta LoBalbo</p>
<p class="first2_noindent"><span class="font5"><strong>The Inventor Says</strong></span></p>
<p class="text_noindent">Kevin Lippert</p>
<p class="first2_noindent"><span class="font5"><strong>The Writer Says</strong></span></p>
<p class="text_noindent">Kevin Lippert</p>
</div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02frontmatter.vue?96c89268